import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const createCommitAction = (mutation) => ({ commit }, payload) => {
  commit(mutation, payload);
};

const actionMutationMap = {
  setShowSliderNav: "setShowSliderNav",
  setCompanyIsNoIntention: "setCompanyIsNoIntention",
  setSeatsIntentionLevel: "setSeatsIntentionLevel",
  setInnerSlider: "setInnerSlider",
  setNavActiveIndex: "setNavActiveIndex",
  setModuleId: "setModuleId",
  setActiveIndex: "setActiveIndex",
  setOpenMenu: "setOpenMenu",
  setIsChange: "setIsChange",
  setSlider: "setSlider",
  setPostbeCrmlevel: "setPostbeCrmlevel",
  setUserOriginalToken: "setUserOriginalToken",
  setUserToken: "setUserToken",
  setMarketerId: "setMarketerId",
  setStafferId: "setStafferId",
  setSchoolId: "setSchoolId",
  setCompanyId: "setCompanyId",
  setUserInfo: "setUserInfo",
  set_companyIsmajor: "set_companyIsmajor",
  set_companyIsassist: "set_companyIsassist",
};

const actions = Object.keys(actionMutationMap).reduce((acc, actionName) => {
  acc[actionName] = createCommitAction(actionMutationMap[actionName]);
  return acc;
}, {});

export default new Vuex.Store({
  state: {
    showSliderNav: true,
    companyIsNoIntention: false,
    seatsIntentionLevel: "",

    navActiveIndex: "2",
    INNER_SLIDER: [],
    module_id: "",
    sliderActiveIndex: "",
    openMenu: ["0"],
    IS_CHANGE: false,
    ORIGINAL_TOKEN: "", //原来的token
    USER_TOKEN: "", //用户Token(假数据)
    MARKETER_ID: "", //会员id
    SATFFER_ID: "", //职工id
    SCHOOL_ID: "", //学校id
    COMPANY_ID: "", //公司id
    USER_INFO: null, //用户信息
    POSTBE_CRMLEVEL: "", //角色权限
    companyIsmajor: "", // company_ismajor  0是免费版 1是普通版   2是专业版
    companyIsassist: "",
    Slider: [
      // {
      // 	title: '首页',
      // 	icon: "crm-sy",
      // 	children: [{
      // 		title: '首页',
      // 		url: '/home'
      // 	}, ]
      // },
      // {
      // 	title: '招生目标管理',
      // 	icon: "crm-zsmb",
      // 	children: [{
      // 			title: '目标管理',
      // 			url: '/Goalmanage/goalManage'
      // 		},
      // 		{
      // 			title: '招生活动管理',
      // 			url: '/Goalmanage/activitiesManage'
      // 		},
      // 		{
      // 			title: '个人招生目标',
      // 			url: '/Goalmanage/mygoalManage'
      // 		},
      // 	]
      // },
      // {
      // 	title: '招生有效名单',
      // 	icon: "crm-zsmdxs",
      // 	children: [{
      // 		title: '招生有效名单',
      // 		url: '/Admissioncue/admissionCue'
      // 	}, ]
      // },
      // {
      // 	title: '意向客户管理',
      // 	icon: "crm-yxkhgl",
      // 	children: [{
      // 		title: '意向客户管理',
      // 		url: '/Customersmanage/custoMersmanage'
      // 	}, ]
      // },
      // {
      // 	title: '柜询试听管理',
      // 	icon: "crm-yxstgl",
      // 	children: [{
      // 			title: '柜询记录管理',
      // 			url: '/Invitationauditionmanage/invitationManage'
      // 		},
      // 		{
      // 			title: '试听记录管理',
      // 			url: '/Invitationauditionmanage/auditionManage'
      // 		},
      // 	]
      // },
      // {
      // 	title: '已报名名单',
      // 	icon: "crm-ybmmd",
      // 	children: [{
      // 		title: '已报名名单',
      // 		url: '/Registeredlist/registeredList'
      // 	}, ]
      // },
      // {
      // 	title: '无意向客户管理',
      // 	icon: "crm-lskhgl",
      // 	children: [{
      // 		title: '无意向客户管理',
      // 		url: '/Losscustomermanage/losscustomerManage'
      // 	}, ]
      // },
      // {
      // 	title: '分析报表',
      // 	icon: "crm-fxbb",
      // 	children: [
      // 		{ title: '校招生柜询报表', url: '/Analysisreport/invitationReport'},
      // 		{ title: '校招生跟踪报表', url: '/Analysisreport/trackReport'},
      // 	]
      // }
    ],
  },
  mutations: {
    setShowSliderNav(state, showSliderNav) {
      state.showSliderNav = showSliderNav;
    },
    setCompanyIsNoIntention(state, companyIsNoIntention) {
      state.companyIsNoIntention = companyIsNoIntention;
    },
    setSeatsIntentionLevel(state, seatsIntentionLevel) {
      state.seatsIntentionLevel = seatsIntentionLevel;
    },
    setInnerSlider(state, slider) {
      state.INNER_SLIDER = slider;
    },
    setNavActiveIndex(state, index) {
      state.navActiveIndex = index;
    },
    setModuleId(state, id) {
      state.module_id = id;
    },
    setActiveIndex(state, index) {
      state.sliderActiveIndex = index;
    },
    setOpenMenu(state, open) {
      state.openMenu = open;
    },
    setIsChange(state, ischange) {
      state.IS_CHANGE = ischange;
    },
    setSlider(state, slider) {
      state.Slider = slider;
    },
    setPostbeCrmlevel(state, postbe_crmlevel) {
      state.POSTBE_CRMLEVEL = postbe_crmlevel;
    },
    setUserOriginalToken(state, original_token) {
      state.ORIGINAL_TOKEN = original_token;
    },
    setUserToken(state, token) {
      state.USER_TOKEN = token;
    },
    setMarketerId(state, id) {
      state.MARKETER_ID = id;
    },
    setStafferId(state, id) {
      state.SATFFER_ID = id;
    },
    setSchoolId(state, id) {
      state.SCHOOL_ID = id;
    },
    setCompanyId(state, id) {
      state.COMPANY_ID = id;
    },
    setUserInfo(state, user_info) {
      state.USER_INFO = user_info;
    },
    set_companyIsmajor(state, companyIsmajor) {
      state.companyIsmajor = companyIsmajor;
    },
    set_companyIsassist(state, companyIsassist) {
      state.companyIsassist = companyIsassist;
    },
  },
  actions,
});
